export const actions = {
    START_FETCHING_CONTACTS: 'START_FETCHING_CONTACTS',
    FETCHING_SUCCESSFUL_CONTACTS: 'FETCHING_SUCCESSFUL_CONTACTS',
    FETCHING_FAILED_CONTACTS: 'FETCHING_FAILED_CONTACTS',

    START_DELETE_CONTACT: 'START_DELETE_CONTACT',
    DELETE_CONTACT_SUCCESSFUL: 'DELETE_CONTACT_SUCCESSFUL',
    DELETE_CONTACT_FAILED: 'DELETE_CONTACT_FAILED',

    START_CREATE_CONTACT: 'START_CREATE_CONTACT',
    CREATE_CONTACT_SUCCESSFUL: 'CREATE_CONTACT_SUCCESSFUL',
    CREATE_CONTACT_FAILED: 'CREATE_CONTACT_FAILED',

    START_UPDATE_CONTACT: 'START_UPDATE_CONTACT',
    UPDATE_CONTACT_SUCCESSFUL: 'UPDATE_CONTACT_SUCCESSFUL',
    UPDATE_CONTACT_FAILED: 'UPDATE_CONTACT_FAILED',

    START_FETCHING_CONTACT: 'START_FETCHING_CONTACT',
    FETCH_CONTACT_SUCCESSFUL: 'FETCH_CONTACT_SUCCESSFUL',
    FETCH_CONTACT_FAILED: 'FETCH_CONTACT_FAILED',
    STORE_CONTACT_DATA: 'STORE_CONTACT_DATA',

    START_EXPORTING_CONTACTS: 'START_EXPORTING_CONTACTS',
    EXPORTING_CONTACTS_SUCCESSFUL: 'EXPORTING_CONTACTS_SUCCESSFUL',
    EXPORTING_CONTACTS_FAILED: 'EXPORTING_CONTACTS_FAILED'
};

export const initialState = {
    listingFetching: false,
    listingResponse: {
        data: [],
        meta: {},
        included: []
    },
    listingError: [],
    singleFetching: false,
    singleError: null,
    deleteSingleError: null
};

export default (state = initialState, { type, response, iri }) => {
    switch (type) {
        case actions.START_FETCHING_CONTACTS: {
            return {
                ...state,
                listingFetching: true
            };
        }
        case actions.FETCHING_SUCCESSFUL_CONTACTS: {
            return {
                ...state,
                listingFetching: false,
                listingResponse: response
            };
        }
        case actions.FETCHING_FAILED_CONTACTS: {
            return {
                ...state,
                listingFetching: false,
                listingError: response
            };
        }
        case actions.START_FETCHING_CONTACT: {
            return {
                ...state,
                singleFetching: true
            };
        }
        case actions.FETCH_CONTACT_SUCCESSFUL: {
            return {
                ...state,
                singleFetching: false
            };
        }
        case actions.FETCH_CONTACT_FAILED: {
            return {
                ...state,
                singleFetching: false
            };
        }
        case actions.STORE_CONTACT_DATA: {
            return { ...state, [iri]: response?.data };
        }
        case actions.DELETE_CONTACT_FAILED: {
            return {
                ...state,
                deleteSingleError: response
            };
        }

        case actions.UPDATE_CONTACT_FAILED: {
            return {
                ...state,
                singleError: response
            };
        }

        default:
            return state;
    }
};
